var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { IconBadgeStructure } from '../components/IconBadgeStructure';
// Styles
import { getIconBadgeStylesBySize } from './getIconBadgeStylesBySize';
import { getBadgeStylesByVariant } from '../../../common/styles/badge/styles/getBadgeStylesByVariant';
// Utils
import styled from 'styled-components';
export var StyledIconBadge = styled(IconBadgeStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  display: grid;\n  grid-row: 1;\n  grid-column: 1;\n  border-radius: 180px;\n\n  ", ";\n  ", "\n"], ["\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  display: grid;\n  grid-row: 1;\n  grid-column: 1;\n  border-radius: 180px;\n\n  ", ";\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return getIconBadgeStylesBySize(size);
}, function (_a) {
    var styleVariant = _a.styleVariant, theme = _a.theme;
    return getBadgeStylesByVariant(styleVariant, theme);
});
var templateObject_1;
//# sourceMappingURL=StyledIconBadge.js.map